import { styled } from "styled-components";
import { CloseIcon } from "@/assets/Icons.tsx";
import { Button } from "@/components/ui/Button.tsx";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 4px;
  border: 1px solid #E8E8E8;
  box-shadow: 1px 3px 3.7px 0px rgba(0, 0, 0, 0.07);
  min-width: 550px;
`;

const ModalHeader = styled.div`
    padding: 17px 15px 19px 23px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    svg {
        cursor: pointer;
    }
`;

const ModalTitle = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0%;
`

const ModalBody = styled.div`
    padding: 0 14px 27px 24px 
`;

interface IModal {
    isOpen: boolean;
    onClose: () => void;
    children?: React.ReactNode;
    title: string;
}

export const Modal = ({ isOpen, onClose, title, children }: IModal) => {
    if (!isOpen) return null;

    return (
        <ModalOverlay>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <ModalHeader>
                    <ModalTitle>
                        {title}
                    </ModalTitle>
                    <Button variant='text' onClick={onClose}>
                        <CloseIcon />
                    </Button>
                </ModalHeader>
                <ModalBody>
                    {children}
                </ModalBody>
            </ModalContent>
        </ModalOverlay>
    );
};
